import buildUrl from 'build-url';

const urlParams   = new URLSearchParams(window.location.search);  // Gets params from url
let   el          = document.documentElement;
let   search      = '';
let   locationLat = null;
let   locationLng = null;
let   filters     = [];

/**
 * Initialises finder components
 */
const init = () => {

	// Get finder element
	// el = document.querySelector('[data-finder]');

	// If it exists
	if (el !== null) {

		// Set common values based on current url params
		if (urlParams.get('search') !== null) {
			search = urlParams.get('search');
		}
		if (urlParams.get('lat') !== null) {
			locationLat = urlParams.get('lat');
		}
		if (urlParams.get('lng') !== null) {
			locationLng = urlParams.get('lng');
		}

		// Get current filters based on checked filter fields in this finder
		filters = getFilterVals();	

		// Event listeners
		el.addEventListener('location-allowed', handleLocationAllowed);
		el.addEventListener('location-blocked', handleLocationBlocked);
		el.addEventListener('filters-updated', handleFiltersUpdated);
		el.addEventListener('search-submitted', handleSearchSubmitted);
		el.addEventListener('clear-search-triggered', handleClearSearchTriggered);

		const searchForm  = el.querySelector('[data-finder-search-form]');
		const searchField = el.querySelector('[data-finder-search-field]');

		// If search form/field exist
		if (searchForm !== null && searchField !== null) {

			// Listen for when search form submitted
			searchForm.addEventListener('submit', (e) => {

				// Prevent normal submission
				e.preventDefault();
				
				// Dispatch new event containing value in search field as detail
				searchForm.dispatchEvent(new CustomEvent('search-submitted', {
					bubbles: true,
					detail: searchField.value
				}));
			});
		}

		// Trigger to clear current search 
		const clearSearchTrigger = el.querySelector('[data-finder-clear-search-trigger]');

		if (clearSearchTrigger !== null) {
			clearSearchTrigger.addEventListener('click', (e) => {
				e.target.dispatchEvent(new Event('clear-search-triggered', {bubbles: true}));
			});
		}
	}
}

/**
 * Handles when a location request was allowed
 * 
 * @param {CustomEvent} e 'location-allowed' event bubbled from 'location-requester' module. Event detail = GeolocationPosition object.
 */
const handleLocationAllowed = (e) => {

	// Get current location coords from event detail
	locationLat = e.detail.coords.latitude;
	locationLng = e.detail.coords.longitude;

	// Set search back to default value
	search = '';

	triggerSearch();
}

/**
 * Handles when a location request was blocked
 * 
 * @param {CustomEvent} e 'location-blocked' event bubbled from 'location-requester' module. Event detail = GeolocationError object.
 */
const handleLocationBlocked = (e) => {
	console.log(e);
}

/**
 * Handles when filters have been updated
 * 
 * @param {CustomEvent} e 'filters-updated' event bubbled from 'filters' module
 */
const handleFiltersUpdated = () => {

	filters = getFilterVals();
	triggerSearch();
}

/**
 * Handles when the search form has been submitted
 * @param {CustomEvent} e 'search-submitted' event. Event detail = search field value
 */
const handleSearchSubmitted = (e) => {
	
	// Set current search term based on event detail
	search = e.detail;

	// Set location lat/lng back to null
	locationLat = null;
	locationLng = null;

	// Trigger new search
	triggerSearch();
}

/**
 * Handle when a request to clear search has been triggered
 */
const handleClearSearchTriggered = () => {
	
	// Clear all params
	search      = '';
	locationLat = null;
	locationLng = null;
	filters     = [];

	// Trigger new search
	triggerSearch();
}

const getFilterVals = () => {

	let currFilters = [];

	// Loop through all field groups
	for (const group of el.querySelectorAll('[data-filters-group]')) {

		// Get key for filters group
		const groupKey  = group.getAttribute('data-filters-group');
		const groupVals = [];

		for (const fld of group.querySelectorAll('[data-filters-field]')) {
			
			if (fld.checked) {
				groupVals.push(fld.value);
			}
		}

		// If any checked fields in group, add group object to filters array
		if (groupVals.length > 0) {
			currFilters.push({
				name: groupKey,
				fields: groupVals
			});
		}
	}
	
	return currFilters;
}

/**
 * Triggers a new search
 */
const triggerSearch = () => {

	const params = {};

	// Add search param if not empty
	if (search.length > 0) {
		params.search = search;
	}

	// Add coords params if not empty
	if (locationLat !== null && locationLng !== null) {
		params.lat = locationLat;
		params.lng = locationLng;
	}

	// Loop through current set filters and add to params
	// for (const group of filters) {
	// 	params[group.name] = group.fields.join(',');
	// }
	if (filters.length > 0) {

		let arrGroups = [];

		for (const group of filters) {
			arrGroups.push(group.name + ':' + group.fields.join(';'));
		}

		params.filters = arrGroups.join('|');
	}

	// Add base path we will be redirecting to
	let urlData = {
		path: window.location.pathname
	};
	// If any params present, add to url
	if (Object.keys(params).length > 0) {
		urlData.queryParams = params;
	}

	// Reload page with params
	window.location = buildUrl(null, urlData);
}

export default init;